import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @returns true if validation passed. An object with the validation id and a message property inside if failed.
 * @example: { "date": { message: "Something went wrong"}}
 */
export const oneOptionSelectedValidator = (control: AbstractControl, form: FormlyFieldConfig) => {
  const model = control.value;
  let oneOptionSelected = false;
  let msg : string = '';
  if (!model) {
    return null;
  }

  try {
    // Iterate through the model to check if at least one option is true
    const mod = Object.entries(model);
    for (const item of mod) {
      // console.log(item);
      if (item[1] === true) {
        oneOptionSelected = true;
        break;
      }
    }
  } catch (err) {
    console.warn("oneOptionSelectedValidator Exception "+err);
  }

  if (!oneOptionSelected) {
     msg = "At least one option should be selected";
  }

  return !msg
  ? null
  : {
    oneOptionSelectedValidator: {
      message: msg,
    }
  };
};
